export function injectWhiteBackground(svgString: string, fill: string = "#ffffff"): string {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, "image/svg+xml");
    const svgEl = doc.documentElement as unknown as SVGSVGElement;
    if (!svgEl || svgEl.nodeName.toLowerCase() !== "svg") return svgString;

    // Ensure namespaces are present
    if (!svgEl.getAttribute("xmlns")) svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    if (!svgEl.getAttribute("xmlns:xlink")) svgEl.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");

    // Check for an existing full-canvas background rect
    const children = Array.from(svgEl.childNodes);
    const hasFullBg = children.some((n) => {
      if (n.nodeType !== 1) return false;
      const el = n as Element;
      if (el.tagName.toLowerCase() !== "rect") return false;
      const w = (el.getAttribute("width") || "").trim();
      const h = (el.getAttribute("height") || "").trim();
      const f = (el.getAttribute("fill") || "").trim().toLowerCase();
      if ((w === "100%" || w === "100%") && (h === "100%" || h === "100%") && f && f !== "none") return true;
      return false;
    });
    if (hasFullBg) return svgString;

    // Inject a white background rect as the first child
    const ns = svgEl.namespaceURI || "http://www.w3.org/2000/svg";
    const rect = doc.createElementNS(ns, "rect");
    rect.setAttribute("x", "0");
    rect.setAttribute("y", "0");
    rect.setAttribute("width", "100%");
    rect.setAttribute("height", "100%");
    rect.setAttribute("fill", fill);
    if (svgEl.firstChild) svgEl.insertBefore(rect, svgEl.firstChild);
    else svgEl.appendChild(rect);

    return new XMLSerializer().serializeToString(svgEl);
  } catch {
    // In case of any parsing error, return original
    return svgString;
  }
}


